import React, { useContext, useState, useMemo } from "react";

import "../ReportDetails/CompanyEmissionVerification/CompanyEmissionVerification.scss";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { ClaimsContext } from "../../services/ClaimsService";
import { ClaimType } from "../../constants/claims";
import { CERWcnTable } from "./CERTables/CERWcnTable";
/**
 * This is the CompanyEmissionVerification component that is being imported in the Routes.js file
 * This component is used to display the Company Emission Verification Reports
 * @returns CompanyEmissionVerification component
 */

const EumrvCompanyEmissionVerification = () => {
    const { userHasClaim } = useContext(ClaimsContext);
    const [refreshTable, setRefreshTable] = React.useState(false);

    const isClient = userHasClaim(ClaimType.Client);

    return (
        <section className="p-4">
            <div>
                <CERWcnTable refresh={refreshTable} isClient={isClient} />
            </div>
        </section>
    );
};


const ErrorMsg = ({ errors, name }) => {
    return errors[name] ? <div className="error-msg">{errors[name].message}</div> : null;
};

ErrorMsg.propTypes = {
    name: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
};

export default EumrvCompanyEmissionVerification;
